import { AdminUserBirthInfoModel } from "./user_birth_info_model.js"
import { RawAdminUserModel } from "./user_model.js";

class RawAdminBirthUserModel extends RawAdminUserModel {

  rawFormFields(item = undefined) {
    return [
      {
        name: "personalInfo",
        type: "nestedModel",
        model: AdminUserBirthInfoModel,
        weight: 12,
      }
    ]
  }
}
const AdminBirthUserModel = new RawAdminBirthUserModel();

export { RawAdminBirthUserModel, AdminBirthUserModel }
